import _ from "lodash";

export function stringOrNull (string)
{
	if (!string)
	{
		return null;
	}

	return string.trim().length > 0
		? string
		: null;
}

export function equals (text1, text2)
{
	return trim(text1.toLowerCase()) === trim(text2.toLowerCase());
}

export function isEmptyOrNull (string)
{
	return string === null || string.trim().length === 0;
}

export function removeWhitespaces (string)
{
	return string.replace(/\s+/g, '');
}

export function trim (text)
{
	return _.trim(text);
}

export function camelize (string)
{
	return string
		.toLowerCase()
		.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

export function startsWith (text, keyword)
{
	return text.toLowerCase().startsWith(keyword.toLowerCase());
}

export function search (text, keyword)
{
	keyword = keyword.replace('-', ' ');

	const parts = keyword.split(' ');

	let isIn = true;

	_.forEach(parts, part =>
	{
		part = _.trim(part);
		part = part.replace('-', '');

		if (
			!text.toLowerCase().includes(part.toLowerCase())
			&& levenshtein(text, part) > getLevenshteinDistance(part)
		)
		{
			isIn = false;

			return false; // break
		}
	});

	return isIn;
}

export function getLevenshteinDistance (text)
{
	if (text.length <= 3)
	{
		return 1;
	}

	if (text.length <= 6)
	{
		return 2;
	}

	if (text.length <= 9)
	{
		return 3;
	}

	return 4;
}

export function stripTags (text)
{
	return text.replace(/<\/?[^>]+(>|$)/g, "");
}

export function removeParagraphs (text)
{
	text = text.replaceAll('<p>', '');

	return text.replaceAll('</p>', '<br/>');
}

export function maxLength (text, maxLength)
{
	if (!text)
	{
		return text;
	}

	return text.length > maxLength
		? (text.substring(0, maxLength) + '...')
		: text;
}

export function nl2br (str)
{
	if (typeof str === 'undefined' || str === null)
	{
		return '';
	}

	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2');
}

export function levenshtein (s, t)
{
	if (s === t)
	{
		return 0;
	}
	var n = s.length, m = t.length;
	if (n === 0 || m === 0)
	{
		return n + m;
	}
	var x = 0, y, a, b, c, d, g, h, k;
	var p = new Array(n);
	for (y = 0; y < n;)
	{
		p[y] = ++y;
	}

	for (; (x + 3) < m; x += 4)
	{
		var e1 = t.charCodeAt(x);
		var e2 = t.charCodeAt(x + 1);
		var e3 = t.charCodeAt(x + 2);
		var e4 = t.charCodeAt(x + 3);
		c = x;
		b = x + 1;
		d = x + 2;
		g = x + 3;
		h = x + 4;
		for (y = 0; y < n; y++)
		{
			k = s.charCodeAt(y);
			a = p[y];
			if (a < c || b < c)
			{
				c = (a > b ? b + 1 : a + 1);
			}
			else
			{
				if (e1 !== k)
				{
					c++;
				}
			}

			if (c < b || d < b)
			{
				b = (c > d ? d + 1 : c + 1);
			}
			else
			{
				if (e2 !== k)
				{
					b++;
				}
			}

			if (b < d || g < d)
			{
				d = (b > g ? g + 1 : b + 1);
			}
			else
			{
				if (e3 !== k)
				{
					d++;
				}
			}

			if (d < g || h < g)
			{
				g = (d > h ? h + 1 : d + 1);
			}
			else
			{
				if (e4 !== k)
				{
					g++;
				}
			}
			p[y] = h = g;
			g = d;
			d = b;
			b = c;
			c = a;
		}
	}

	for (; x < m;)
	{
		var e = t.charCodeAt(x);
		c = x;
		d = ++x;
		for (y = 0; y < n; y++)
		{
			a = p[y];
			if (a < c || d < c)
			{
				d = (a > d ? d + 1 : a + 1);
			}
			else
			{
				if (e !== s.charCodeAt(y))
				{
					d = c + 1;
				}
				else
				{
					d = c;
				}
			}
			p[y] = d;
			c = a;
		}
		h = d;
	}

	return h;
}

export function decodeBase64 (base64)
{
	const text = window.atob(base64);
	const length = text.length;
	const bytes = new Uint8Array(length);
	for (let i = 0; i < length; i++)
	{
		bytes[i] = text.charCodeAt(i);
	}
	const decoder = new TextDecoder(); // default is utf-8
	return decoder.decode(bytes);
}
